import { AgentStoreSearchInputInterface } from 'common/data/agent/store/search/input.interface';
import { AgentSerpStoreStateParamsInterface } from 'common/module/agent-serp/store/state-params.interface';

/**
 * TODO-FE[later] This file is too deep in folders, most likely there is a simpler solution
 */
export class AgentSerpStoreParamsSearchInputAdapter {
  /**
   * Transforms AgentSerpStoreParams to AgentStoreSearchInput
   */
  public getData(params: AgentSerpStoreStateParamsInterface): AgentStoreSearchInputInterface {
    // Search input
    const input: AgentStoreSearchInputInterface = {};

    /**
     * TODO-FE[later] Make params a nested object:
     * - remove this "root" keys extraction
     * - replace page test by params.hasOwnProperty('page')
     * - replace filter test by params.hasOwnProperty('filter')
     */
    const keys = Object.keys(params).map((key) => key.replace(/\[[^[\]]+\]/gi, '')); // replace anything between brackets by ''

    if (keys.indexOf('page') > -1) {
      input.page = {};
    }

    if (keys.indexOf('filter') > -1) {
      input.filter = {};
    }

    // Page
    if (params['page[limit]']) {
      input.page.limit = params['page[limit]'];
    }

    if (params['page[number]']) {
      input.page.number = params['page[number]'];
    }

    // Sort
    if (params.sort) {
      input.sort = params.sort;
    }

    // Filters
    if (params['filter[category_id]']) {
      input.filter.category_id = params['filter[category_id]'];
    }

    if (params['filter[language_ids]']) {
      input.filter.language_ids = params['filter[language_ids]'];
    }

    if (params['filter[nationality]']) {
      input.filter.nationality = params['filter[nationality]'];
    }

    if (params['filter[id]']) {
      input.filter.id = params['filter[id]'];
    }

    if (params['filter[broker_id]']) {
      input.filter.broker_id = params['filter[broker_id]'];
    }

    if (params['filter[location_id]']) {
      input.filter.location_id = params['filter[location_id]'];
    }

    if (params['filter[name]']) {
      input.filter.name = params['filter[name]'];
    }

    return input;
  }
}
